<script setup lang="ts">
import NavigationProgress from '@/components/common/NavigationProgress.vue';
import { ToastViewport } from '@/components/ui';
import { useMe } from '@/composables/api/useAuth';
import { useAuthStore } from '@/stores/auth';
import { useUiStore } from '@/stores/ui';
import { computed } from 'vue';
import { RouterView } from 'vue-router';

const authStore = useAuthStore();
const uiStore = useUiStore();

// Keep auth state in sync with server (refetches on window focus)
useMe();

// Global loading overlay
const showGlobalLoading = computed(
    () => uiStore.isGlobalLoading || authStore.isLoading,
);
</script>

<template>
    <div class="app-root">
        <!-- Route navigation progress bar -->
        <NavigationProgress />

        <!-- Global Loading Overlay with fade transition -->
        <Transition name="loading-fade">
            <div v-if="showGlobalLoading" class="app-loading-overlay">
                <div class="app-loading-content">
                    <div class="app-spinner" />
                    <p
                        v-if="uiStore.loadingMessage"
                        class="app-loading-message"
                    >
                        {{ uiStore.loadingMessage }}
                    </p>
                </div>
            </div>
        </Transition>

        <!-- Main App Content -->
        <RouterView v-slot="{ Component, route }">
            <component :is="Component" :key="route.path" />
        </RouterView>

        <!-- Toast Notifications -->
        <ToastViewport />
    </div>
</template>
